export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";